import React from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';

import { iotOnDateFormat } from '../../../../common/services/ValidationRules';
import { ChargerLastUpdate } from '../../../../common/components/ChargerLastUpdate';
import { Dialog } from '../../../../common/components/Dialog/Dialog';
import Button from '../../../../common/components/Button/Button';

import ChargerDetails from '../../index';

import './_styles.scss';

const ChargerDetailsModal = ({ closeChangerModal, chargerModalDataIsFetching, chargerModalData, user, chargerId, tab, setActiveTab }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const updateTimestamp = get(chargerModalData, 'update_reason_timestamp', '');
  const updateReason = get(chargerModalData, 'update_reason', '');
  const timeToShow = updateTimestamp && !chargerModalDataIsFetching ? `${moment.utc(updateTimestamp).format(iotOnDateFormat)} UTC` : '';

  const timestampWithTooltip = <ChargerLastUpdate updateReason={updateReason} timeToShow={timeToShow} />;

  const actions = [
    <Button key="cancel-btn" color="secondary" onClick={() => closeChangerModal()}>
      Cancel
    </Button>,
  ];

  const titleText = `Charger: ${chargerId}`;
  const titleElement = (
    <div className="title-container">
      <div className="title-container-title">{titleText}</div>
      <div className="title-container-time">{timestampWithTooltip}</div>
    </div>
  );

  return (
    <Dialog
      className="charger-details-modal"
      title={titleElement}
      maxWidth={false}
      actions={actions}
      contentClassName="charger-details-modal"
      scroll="body"
      open
      fullWidth
      onClose={() => closeChangerModal()}
      autoScrollBodyContent
    >
      <ChargerDetails
        setActiveTab={setActiveTab}
        modal
        user={user}
        match={{ params: { chargerId, tab: tab || 'details' } }}
        chargerId={chargerId}
        activeTab={tab || 'details'}
        location={location}
        navigate={navigate}
      />
    </Dialog>
  );
};

export default ChargerDetailsModal;
